import { render, staticRenderFns } from "./GiveLog.vue?vue&type=template&id=a7ca5332&scoped=true&"
import script from "./GiveLog.vue?vue&type=script&lang=js&"
export * from "./GiveLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ca5332",
  null
  
)

export default component.exports